import { Table } from '@chakra-ui/react';
import { IAccountRespSchema } from '@monetize/types/app';
import { Maybe } from '@monetize/types/common';
import { useEffect } from 'react';
import { MText } from '../../../components/Monetize';
import { useRelatedRecordValues } from './AccountMerge.hooks';
import { ThData, TrData } from './AccountMergeRenderers';
import { AccountToKeep } from './AccountMergeTable.types';

export function RelatedRecordsSummary({
  mainAccount,
  otherAccount,
  accountToKeep,
  onRelatedValuesChange,
}: {
  mainAccount: IAccountRespSchema;
  otherAccount?: Maybe<IAccountRespSchema>;
  accountToKeep: AccountToKeep;
  onRelatedValuesChange: (
    retainPaymentGatewayAccountOptions: ReturnType<
      typeof useRelatedRecordValues
    >,
  ) => void;
}) {
  const relatedRecordValues = useRelatedRecordValues(mainAccount, otherAccount);
  const { values } = relatedRecordValues;

  useEffect(() => {
    onRelatedValuesChange(relatedRecordValues);
  }, [relatedRecordValues, onRelatedValuesChange]);

  if (!values.length) {
    return null;
  }

  return (
    <>
      <Table.Row _hover={{ bg: 'transparent' }}>
        <Table.ColumnHeader
          textTransform="none"
          fontWeight={500}
          letterSpacing="inherit"
          textAlign="right"
          width="200px"
          borderRight="1px solid {colors.tGray.back}"
        >
          <MText>Related Data</MText>
        </Table.ColumnHeader>
        <Table.Cell colSpan={2} />
      </Table.Row>
      {values.map(({ label, account1Value, account2Value }) => (
        <Table.Row key={label} _hover={{ fontWeight: '600' }}>
          <ThData>{label}</ThData>
          <TrData
            blankRenderer={() => null}
            borderRight="1px solid {colors.tGray.back}"
            cellStyle={accountToKeep === AccountToKeep.MAIN ? 'KEEP' : 'DELETE'}
          >
            {account1Value}
          </TrData>
          <TrData
            blankRenderer={() => null}
            cellStyle={
              otherAccount
                ? accountToKeep === AccountToKeep.OTHER
                  ? 'KEEP'
                  : 'DELETE'
                : 'NONE'
            }
          >
            {account2Value}
          </TrData>
        </Table.Row>
      ))}
    </>
  );
}
